<template>
  
  <the-header></the-header>
  <div class="career-container"> 

  </div>
  <the-footer/>
</template>

<script>
export default {

}
</script>

<style scoped>
.career-container{
  min-height: 75vh;
}
</style>